export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14122.97d05bf0.jpg";